export const formatCurrency = (amount) => {
  return `${amount.toLocaleString()} GNF`
}

export const formatDate = (date) => {
  return new Date(date).toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

export const generateProductCode = (nextId) => {
  return `PRD-${nextId.toString().padStart(4, '0')}`
}

export const generateArticleName = (productsLength) => {
  const articleCount = productsLength + 1
  return `Article ${articleCount}`
}
